import { useCallback } from "react";
import { apolloClient } from "@td/ui";
import FIND_TASK_QUERY from "../queries/find-task.graphql";

const useTaskSearch = () => {
  const findTask = useCallback(async (taskId) => {
    try {
      const { data: { careTeamTask }} = await apolloClient.query({
        query: FIND_TASK_QUERY,
        variables: {
          taskId: parseInt(taskId),
        },
        fetchPolicy: "network-only",
      });

      return careTeamTask;
    } catch (e) {
      return null;
    }
  }, [apolloClient]);

  return {
    findTask,
  };
};

export default useTaskSearch;
